<template>
  <v-card color="white" class="rounded">
    <v-card-title class="mb-0">
      <h4 class="subheading">Other Settings</h4>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-flex>
        <v-switch
          color="#d13b55"
          v-model="shareSpendOvations"
          label="Allow peer-to-peer Ovations sharing"
          :disabled="loading"
          hide-details
        ></v-switch>
      </v-flex>
      <v-flex>
        <v-switch
          color="#d13b55"
          v-model="enableBounty"
          label="Bounty Board"
          :disabled="loading"
          hide-details
        ></v-switch>
      </v-flex>
      <v-flex>
        <v-switch
          color="#d13b55"
          v-model="enableRichTextInDashboard"
          label="Media Previews in Dashboard"
          :disabled="loading"
          hide-details
        ></v-switch>
      </v-flex>
      <v-flex>
        <v-switch
          color="#d13b55"
          v-model="enableLearnAndEarn"
          label="Learn & Earn"
          :disabled="loading"
          hide-details
        ></v-switch>
      </v-flex>
      <v-flex v-if="$store.getters.isSuperAdmin">
        <v-switch
          color="#d13b55"
          v-model="allowGivingNoOvations"
          label="Allow giving no Ovations"
          :disabled="loading"
          hide-details
        ></v-switch>
      </v-flex>
      <v-flex v-if="$store.getters.isSuperAdmin">
        <div class="d-inline-flex" style="align-items: center">
          <v-switch
            color="#d13b55"
            v-model="monthlyBilling"
            label="Monthly Billing"
            :disabled="loading"
            hide-details
          ></v-switch>
          <v-text-field
            v-if="monthlyBilling"
            class="ml-4"
            type="number"
            :rules="amountRules"
            :min="1"
            v-model="perUserRate"
            hint="Per User Rate"
            :persistent-hint="true"
            placeholder="Per User Rate"
            prefix="$"
            :disabled="!monthlyBilling || loading"
          ></v-text-field>
          <span v-if="monthlyBilling" class="ml-4 mt-4"
            >Members Count:
            <span class="font-weight-medium">{{ membersCount }}</span></span
          >
        </div>
        <div
          v-if="monthlyBilling"
          class="d-inline-flex"
          style="align-items: center; margin-left: 46px"
        >
          <span class="mt-2">Additional Support</span>
          <v-text-field
            class="ml-3"
            type="number"
            :min="0"
            v-model="additionalSupport"
            placeholder="Additional Support"
            prefix="$"
            :disabled="!monthlyBilling || loading"
          ></v-text-field>
        </div>
        <div v-if="monthlyBilling" class="ml-4 mt-1">
          <v-btn
            style="margin-left: 20px"
            outline
            small
            color="#d13b55"
            :disabled="!monthlyBilling || loading"
            @click.prevent="generateInvoice"
            >Generate Invoice</v-btn
          >
        </div>
      </v-flex>
      <v-flex v-if="$store.getters.isSuperAdmin">
        <div
          class="d-inline-flex"
          style="align-items: center; margin-left: 46px"
        >
          <span class="mt-2">Online Payment Fees</span>
          <v-text-field
            class="ml-3"
            type="number"
            :min="0"
            v-model="onlinePaymentApiFees"
            placeholder="Online Payment Fees"
            suffix="%"
            :hint="
              'If not set app will use default value: ' +
              $store.state.onlinePaymentApiFees
            "
            :disabled="loading"
          ></v-text-field>
        </div>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <div class="ml-2 mb-2">
        <v-btn
          class="btn-rounded-medium white--text"
          color="#d13b55"
          @click.prevent="saveOrgSettings"
          :disabled="loading"
          >Save</v-btn
        >
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import validationRules from "@/js/validationRules.js";

export default {
  name: "OrgSettingsComponent",
  data() {
    return {
      loading: false,
      orgDetails: {},
      shareSpendOvations: false,
      enableBounty: false,
      enableLearnAndEarn: false,
      enableRichTextInDashboard: false,
      allowGivingNoOvations: false,
      monthlyBilling: false,
      perUserRate: 0,
      membersCount: 0,
      additionalSupport: 0,
      onlinePaymentApiFees: 0,
      amountRules: validationRules.integerRules,
    };
  },
  computed: {},
  methods: {
    getOrgDetails: function () {
      this.orgDetails = JSON.parse(
        JSON.stringify((this.$store.state.userSelf.currentOrg || {}).org)
      );
      if (this.orgDetails) {
        this.shareSpendOvations = this.orgDetails.shareSpendOvations;
        this.enableBounty = this.orgDetails.enableBounty;
        this.enableRichTextInDashboard =
          this.orgDetails.enableRichTextInDashboard;
        this.allowGivingNoOvations = this.orgDetails.allowGivingNoOvations;
        this.monthlyBilling = this.orgDetails.monthlyBilling;
        this.perUserRate = this.orgDetails.perUserRate;
        this.additionalSupport = this.orgDetails.additionalSupport;
        this.onlinePaymentApiFees = this.orgDetails.onlinePaymentApiFees;
        this.enableLearnAndEarn = this.orgDetails.enableLearnAndEarn;
      }
    },
    getMemberCount: function () {
      if (this.$store.getters.isSuperAdmin) {
        axios
          .get(
            "/api/org/member/count/" + this.$store.getters.getOrgIdentifier,
            this.$store.state.axiosConfig
          )
          .then((response) => {
            this.membersCount = response.data;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    saveOrgSettings: function () {
      // Validation
      if (parseFloat(this.onlinePaymentApiFees) < 0) {
        // Display Message
        this.$store.commit("replaceSnackbar", {
          message: "Enter a valid number for online payment fees",
          messageType: "warning",
        });
        return;
      }

      this.loading = true;

      // Display Message
      this.$store.commit("replaceSnackbar", {
        message: "Saving organization settings...",
        messageType: "warning",
      });

      const params = {
        subdomain: this.orgDetails.subdomain,
        shareSpendOvations: this.shareSpendOvations,
        enableBounty: this.enableBounty,
        enableRichTextInDashboard: this.enableRichTextInDashboard,
        allowGivingNoOvations: this.allowGivingNoOvations,
        monthlyBilling: this.monthlyBilling,
        perUserRate: parseFloat(this.perUserRate),
        additionalSupport: parseFloat(this.additionalSupport),
        onlinePaymentApiFees: parseFloat(this.onlinePaymentApiFees),
        enableLearnAndEarn: this.enableLearnAndEarn,
      };

      axios
        .put("/api/org/settings", params, this.$store.state.axiosConfig)
        .then((response) => {
          // Sync settings app wide
          this.$store.state.userSelf.currentOrg.org.shareSpendOvations =
            this.shareSpendOvations;
          this.$store.state.userSelf.currentOrg.org.enableBounty =
            this.enableBounty;
          this.$store.state.userSelf.currentOrg.org.enableRichTextInDashboard =
            this.enableRichTextInDashboard;
          this.$store.state.userSelf.currentOrg.org.allowGivingNoOvations =
            this.allowGivingNoOvations;
          this.$store.state.userSelf.currentOrg.org.monthlyBilling =
            this.monthlyBilling;
          this.$store.state.userSelf.currentOrg.org.perUserRate =
            this.perUserRate;
          this.$store.state.userSelf.currentOrg.org.additionalSupport =
            this.additionalSupport;
          this.$store.state.userSelf.currentOrg.org.onlinePaymentApiFees =
            this.onlinePaymentApiFees;
          this.$store.state.userSelf.currentOrg.org.enableLearnAndEarn =
            this.enableLearnAndEarn;

          // Display Success message
          this.$store.commit("replaceSnackbar", {
            message: "Organization Settings Saved.",
          });

          this.loading = false;
        })
        .catch((e) => {
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Organization Settings was NOT saved.<br><strong>" +
              e.response.data.message +
              "</strong>",
            messageType: "error",
          });

          this.loading = false;
        });
    },
    generateInvoice: function () {
      if (this.$store.getters.isSuperAdmin) {
        this.loading = true;

        // Display Message
        this.$store.commit("replaceSnackbar", {
          message: "Generating invoice, please wait...",
          messageType: "warning",
        });

        axios
          .post(
            "/api/org/invoice/generate/" + this.$store.getters.getOrgIdentifier,
            {},
            this.$store.state.axiosConfig
          )
          .then((response) => {
            // Display Success message
            this.$store.commit("replaceSnackbar", {
              message: "Invoice has been generated and sent via email",
            });

            this.loading = false;
          })
          .catch((e) => {
            // check/ handle 401 (Unauthorized) error
            this.$store.dispatch("error401Response", e);

            // Display Error Message
            this.$store.commit("replaceSnackbar", {
              message:
                "Error. Invoice was not generated.<br><strong>" +
                e.response.data.message +
                "</strong>",
              messageType: "error",
            });

            this.loading = false;
          });
      }
    },
  },
  beforeMount() {
    this.getOrgDetails();
    this.getMemberCount();
  },
  watch: {
    // Sync when current org updated/changed
    "$store.state.userSelf.currentOrg.org": function () {
      this.getOrgDetails();
      this.getMemberCount();
    },
  },
};
</script>
